export default "<img\n  *ngIf=\"visible\"\n  class=\"trb-unlock-indicator\"\n  [src]=\"iconPath\"\n  alt=\"\"\n/>\n";